import { Either } from 'funfix-core';
import { Record } from 'immutable';
import { foldSPIPermissionCheckResult } from '../spi/Permissions';
export const makePermissionCheckResultFailure = Record({
  allowed: false,
  message: '',
  key: 'noAddonManagePermission'
});
export const makePermissionCheckResultSuccess = Record({
  allowed: true
});
export const makePermissionCheckResultFromSPI = pc => foldSPIPermissionCheckResult(pc)(s => Either.right(makePermissionCheckResultSuccess(s)), f => Either.left(makePermissionCheckResultFailure(f)));